import { inject, Injectable } from '@angular/core';
import { Client } from '@stomp/stompjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TournamentEndpointService } from '@api';

@Injectable({
  providedIn: 'root',
})
export class WebsocketService {
  snackbar = inject(MatSnackBar);
  tournamentService = inject(TournamentEndpointService);
  client: Client | undefined;

  public ensureConnected(username: string) {
    if (this.client === undefined) {
      this.client = new Client({
        brokerURL: `ws://${this.tournamentService.configuration.basePath?.split('//')[1]}/ws`,
        onConnect: () => {
          this.client!.subscribe('/partypics/notifications/' + username, message => {
            this.snackbar.open(JSON.parse(message.body).message, 'X');
          });
        },
      });
      this.client.activate();
    }
  }

  public disconnect() {
    this.client?.deactivate();
    this.client = undefined;
  }
}
